import { render, staticRenderFns } from "./backendverwaltung.vue?vue&type=template&id=2b61b1d0&scoped=true&"
import script from "./backendverwaltung.vue?vue&type=script&lang=js&"
export * from "./backendverwaltung.vue?vue&type=script&lang=js&"
import style0 from "./backendverwaltung.vue?vue&type=style&index=0&id=2b61b1d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b61b1d0",
  null
  
)

export default component.exports